import type { CSSProperties } from "react";

/**
 * ظاهرِ تاس (docs/store-plan.md، فازِ ۴) — آینه‌ی BoardSkins.Dice در اپ
 * (MobileGame/Assets/Scripts/UI/Board/BoardSkins.cs) و diceSkins ِ سرور (internal/economy/catalog.go).
 *
 * تاس در وب خریده نمی‌شود (پرداخت فقط در اپ است)، ولی تاسِ هر بازیکن سرِ میز دیده می‌شود: سرور شناسه را
 * روی صندلی می‌فرستد (Seat.dice) و Die3D با همین رنگ‌ها می‌کشدش. شناسه‌ی ناشناس (قلمِ تازه‌ی پنل) عاج است.
 * فقط ظاهر: خال روی هر رنگی خوانا می‌ماند و «یک» رنگِ جدا دارد.
 */
type Skin = {
  fa: string;
  /** شیبِ رو: روشن، میانه، تیره. */
  face: [string, string, string];
  /** مکعبِ درونی (لای لبه‌ها). */
  core: string;
  /** شیبِ خال و خالِ «یک». */
  pip: [string, string];
  one: [string, string];
};

export const DICE_SKINS: Record<string, Skin> = {
  dice_anar: { fa: "اناری", face: ["#e0566a", "#b0202c", "#70121c"], core: "#70121c", pip: ["#ffffff", "#f4e2c8"], one: ["#fff0b0", "#e8b44a"] },
  dice_shab: { fa: "شبِ نقره‌ای", face: ["#4a5070", "#22263a", "#10121e"], core: "#10121e", pip: ["#ffffff", "#c8d0e0"], one: ["#c4e4ff", "#4a9ae8"] },
  dice_lajvard: { fa: "لاجورد و طلا", face: ["#4a6ad0", "#1e3e96", "#10225c"], core: "#10225c", pip: ["#fff2c0", "#d8a840"], one: ["#fffbe0", "#f0d070"] },
  dice_firuze: { fa: "فیروزه", face: ["#7ae2da", "#26b2aa", "#14706c"], core: "#14706c", pip: ["#ffffff", "#e8e4d0"], one: ["#d07040", "#7a2c10"] },
  dice_khatam: { fa: "خاتم", face: ["#a8744a", "#7a4a28", "#462814"], core: "#462814", pip: ["#fff6e0", "#e0c898"], one: ["#ffe6a0", "#c89a3a"] },
  dice_tala: { fa: "طلای ناب", face: ["#fff0b0", "#e8be56", "#a07422"], core: "#a07422", pip: ["#6a4420", "#2c1806"], one: ["#e05050", "#8a1414"] },
};

/** متغیرهای CSS ِ تاسِ این شناسه روی ‎.d3 — خالی برای عاج (پیش‌فرضِ style.css). */
export function diceVars(skin?: string): CSSProperties {
  const s = skin ? DICE_SKINS[skin] : undefined;
  if (!s) return {};
  return {
    "--d3-f1": s.face[0], "--d3-f2": s.face[1], "--d3-f3": s.face[2], "--d3-core": s.core,
    "--d3-p1": s.pip[0], "--d3-p2": s.pip[1], "--d3-r1": s.one[0], "--d3-r2": s.one[1],
  } as CSSProperties;
}
